import { getRangeValue, resetTerms, TJsonQuery, TJsonQueryRangeKeys } from '../../../JsonQuery';
import { TTagsManager } from '../types/tag';
import { createTagValue } from './createTagValue';
import { fillLabelTemplate } from './fillLabelTemplate';

interface IParams {
  jsonQueryKey: TJsonQueryRangeKeys;
  template: string;
  id: string;
  isApplicable?: (jsonQuery: TJsonQuery) => boolean;
}

export const createRangeTagManager = ({ jsonQueryKey, template, id, isApplicable }: IParams): TTagsManager => ({
  id,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    if (isApplicable && !isApplicable(jsonQuery)) {
      return null;
    }

    const rangeValue = getRangeValue(jsonQueryKey)(jsonQuery);

    if (rangeValue === null) {
      return null;
    }

    const { gte, lte } = rangeValue;
    const from = gte ? `от ${gte}` : '';
    const to = lte ? `до ${lte}` : '';
    const rangeText = gte === lte ? to : `${from} ${to}`.trim();

    return [{ label: fillLabelTemplate(template, rangeText), value: createTagValue(id) }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms([jsonQueryKey])(jsonQuery),
});
